import { Folder } from "lucide-react";
import { formatDate } from "../../utils/formatDate";

export type DocumentListRow = {
  rentProcessId: number;
  propertyId: number;
  name: string;
  updated_at: string;
};

const HEADER_CELL =
  "whitespace-nowrap border-x-0 border-b-0 border-l-0 border-r-0 border-t-0 px-1.5 py-2 text-left text-xs font-semibold text-slate-700";
const BODY_CELL =
  "border-x-0 border-b-0 border-l-0 border-r-0 border-t-0 px-1.5 py-2 text-[13px] text-slate-600";

export function DocumentsListTable({
  rows,
  onOpenDocuments,
}: {
  rows: DocumentListRow[];
  onOpenDocuments: (rentProcessId: number) => void;
}) {
  return (
    <div className="relative mt-4 overflow-x-auto overflow-hidden rounded-t-xl">
      <table className="min-w-[720px] w-full border-separate border-spacing-0 border-none text-[13px] font-[inherit]">
        <thead className="bg-slate-50">
          <tr>
            <th className={`${HEADER_CELL} rounded-tl-xl`}>Cliente</th>
            <th className={HEADER_CELL}>Imóvel</th>
            <th className={HEADER_CELL}>Última atualização</th>
            <th className={`${HEADER_CELL} rounded-tr-xl`}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              key={row.rentProcessId}
              className={`transition ${
                rowIndex % 2 === 0
                  ? "bg-white hover:bg-slate-50"
                  : "bg-slate-50/90 hover:bg-slate-100/90"
              }`}
            >
              <td className={`${BODY_CELL} font-medium text-slate-700`}>
                {row.name}
              </td>
              <td className={`${BODY_CELL} whitespace-nowrap font-medium text-slate-700`}>
                #{row.propertyId}
              </td>
              <td className={`${BODY_CELL} whitespace-nowrap`}>
                {formatDate(row.updated_at)}
              </td>
              <td className={`${BODY_CELL} whitespace-nowrap`}>
                <button
                  type="button"
                  title="Ver documentos"
                  aria-label="Ver documentos"
                  className="inline-flex rounded-lg p-1.5 text-sky-500 transition hover:bg-sky-50"
                  onClick={() => onOpenDocuments(row.rentProcessId)}
                >
                  <Folder className="h-4 w-4" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
